// extracted by mini-css-extract-plugin
export default {"planSubTitle":"AnnualPlanCard_planSubTitle__iZljr","planDisclaimer":"AnnualPlanCard_planDisclaimer__RRLXL"};